import { IRequestForProposalStrategy } from 'types/graphqlTypes'

export enum EditCategories {
  eligibilityCriteria = 'eligibilityCriteria',
  thresholdManagement = 'thresholdManagement',
}

export enum EligibilityCriteriaFields {
  dropType = 'Drop Type',
  equipment = 'Equipment',
  riskyAuditLevel = 'Risky Audit Level',
  contractDuration = 'Contract Duration',
  pickupMarketCenterDistance = 'Pickup Market Center Distance',
  deliveryMarketCenterDistance = 'Delivery Market Center Distance',
  annualVolume = 'Annual Volume',
  marketDemandScore = 'Market Demand Score',
  extraStops = 'Number of Stops',
  effectiveMileage = 'Effective Mileage',
}

export enum ThresholdManagementFields {
  datVariance = 'DAT Variance',
  negativeMarginRisk = 'Negative Margin Risk',
  minimumMargin = 'Minimum Margin',
}

export enum ValidStrategyMatrices {
  volumeToLengthOfHaul = 'volumeToLengthOfHaul',
  volumeToDesirabilityLow = 'volumeToDesirabilityLow',
  volumeToDesirabilityMedium = 'volumeToDesirabilityMedium',
  volumeToDesirabilityHigh = 'volumeToDesirabilityHigh',
  desirabilityToPickupMarket = 'desirabilityToPickupMarket',
  equipmentToPickupMarket = 'equipmentToPickupMarket',
  lengthOfHaulToCostPctDat7 = 'lengthOfHaulToCostPctDat7',
}

export interface IStrategyMatrixOption {
  label: string
  value: ValidStrategyMatrices
}

export interface IMatrixRowOrColumn {
  label: string
  value: string
}

export enum MatrixAccessOrders {
  columnFirst = 'columnFirst',
  rowFirst = 'rowFirst',
}

export type StrategyMatrixValue = string | number

export type StrategyMatrix = Record<string, Record<string, StrategyMatrixValue>>

export type Strategy = Partial<IRequestForProposalStrategy>

export interface ISelectOption {
  label: string
  value: string
}

export enum ConditionTypes {
  equal = 'eq',
  greaterThan = 'gt',
  lessThan = 'lt',
  greaterThanOrEqualTo = 'gte',
  lessThanOrEqualTo = 'lte',
}

export interface ICriteriaCondition {
  value: string | number
  condition: ConditionTypes
}

export interface ILaneCriteria {
  isPuDrop: boolean
  isDelDrop: boolean
  equipment?: string[]
  liveAuditRiskLevel?: string[]
  extraStops?: ICriteriaCondition
  annualVolume?: ICriteriaCondition
  effectiveMileage?: ICriteriaCondition
  marketDemandScore?: ICriteriaCondition
  puDistMarketCenter?: ICriteriaCondition
  delDistMarketCenter?: ICriteriaCondition
  contractDurationInMonths?: ICriteriaCondition
}

export enum ValidCriteriaConditions {
  extraStops = 'extraStops',
  annualVolume = 'annualVolume',
  effectiveMileage = 'effectiveMileage',
  marketDemandScore = 'marketDemandScore',
  puDistMarketCenter = 'puDistMarketCenter',
  delDistMarketCenter = 'delDistMarketCenter',
  contractDurationInMonths = 'contractDurationInMonths',
}

export interface IVarianceFlags {
  datAnchor?: ICriteriaCondition
  negMarginRisk?: ICriteriaCondition
}

export enum DropTypes {
  dropDrop = 'dropDrop',
  dropLive = 'dropLive',
  liveDrop = 'liveDrop',
  liveLive = 'liveLive',
}

export interface IDropStrategyOption {
  label: string
  value: DropTypes
}

export enum RiskyAuditLevels {
  level1 = 'Level 1',
  level2 = 'Level 2',
  level3 = 'Level 3',
  level4 = 'Level 4',
  level5 = 'Level 5',
  level6 = 'Level 6',
  manualAudit = 'manual_audit',
  doNotQuote = 'do_not_quote',
}

export enum MarketCenterDistanceTypes {
  pickup = 'pickup',
  delivery = 'delivery',
}
